export default "__VITE_ASSET__3xht$EPL__"